import React from 'react';
import { Star } from 'lucide-react';
import { reviews } from '../mockData';

const ReviewsPage = () => {
  return (
    <div className="reviews-page">
      <section className="page-hero">
        <div className="page-hero-content">
          <h1 className="page-hero-title">Customer Reviews</h1>
          <p className="page-hero-subtitle">
            See what our satisfied customers across Metro Atlanta have to say
          </p>
          <div className="page-hero-rating">
            <div className="rating-stars-huge">★★★★★</div>
            <span className="rating-text-huge">5.0 Google Rating</span>
          </div>
        </div>
      </section>

      <section className="reviews-list-section">
        <div className="reviews-list-grid">
          {[...reviews, ...reviews].map((review, index) => (
            <div key={index} className="review-detail-card">
              <div className="review-detail-header">
                <div className="review-detail-stars">
                  {[...Array(review.rating)].map((_, i) => (
                    <Star key={i} size={24} fill="var(--brand-primary)" color="var(--brand-primary)" />
                  ))}
                </div>
                <span className="review-detail-date">{review.date}</span>
              </div>
              <p className="review-detail-text">"{review.text}"</p>
              <div className="review-detail-author">
                <div className="author-avatar">{review.name.charAt(0)}</div>
                <span className="author-name">{review.name}</span>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default ReviewsPage;